import { CommonModule } from '@angular/common';
import { DfIconModule } from '../../../../icon';
import { NgModule } from '@angular/core';

import { DfButtonSplitComponent } from './button-split.component';
import { DfButtonSplitMenuItemComponent } from './button-split-menu-item.component';

@NgModule({
  imports: [CommonModule, DfIconModule],
  exports: [DfButtonSplitComponent],
  declarations: [DfButtonSplitComponent, DfButtonSplitMenuItemComponent],
  providers: [],
})
export class DfButtonSplitModule {}
